import { z } from "zod";

export const LiProfileVisitsEntrySchema = z.object({
	id: z.number(),
	liProfileVisitsId: z.number(),
	url: z.string(),
});

export type LiProfileVisitsEntry = z.infer<typeof LiProfileVisitsEntrySchema>;
